import React from "react";
import styled from "styled-components";
import Copy from "@nib-components/copy";
import colors from "@nib-components/colors";
import FeaturePanel from "@nib-components/feature-panel";
import { colorSageGreen40 } from "@nib-components/theme";

import { SecuritySystemIcon, EmailSystemIcon, ComputerSystemIcon } from "@nib/icons";

const StyledFeaturePanel = styled(FeaturePanel)`
  background: ${colorSageGreen40};
`;

const ProductCTA = ({ title }) => {
  return (
    <StyledFeaturePanel title={title || "What happens next?"} space={2}>
      <FeaturePanel.Feature icon={EmailSystemIcon} title="Set up your learning account">
        <Copy align="center">
          You will receive an email with a link to activate your learning account.
        </Copy>
      </FeaturePanel.Feature>
      <FeaturePanel.Feature icon={SecuritySystemIcon} title="Create your password">
        <Copy align="center">
          Set a password for your account so you can come back to your learning at any time.
        </Copy>
      </FeaturePanel.Feature>
      <FeaturePanel.Feature icon={ComputerSystemIcon} title="Start learning">
        <Copy align="center">You&apos;re ready to start the first module of your course.</Copy>
      </FeaturePanel.Feature>
    </StyledFeaturePanel>
  );
};

export default ProductCTA;
